import request from "./../utils/request";

export function getAppSyncApiKey() {
    return request({
        url: `/appsync/key`,
        method: "get",
    }).then((res) => {
        return res.data.apiKey;
    });
}
